<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo () {
    return {
      title: 'Festival Foods',
      titleTemplate: '%s'
    }
  }
}
</script>
